import { render } from "./Boutique.vue?vue&type=template&id=0dc397c8&scoped=true"
import script from "./Boutique.vue?vue&type=script&lang=js"
export * from "./Boutique.vue?vue&type=script&lang=js"

import "./Boutique.vue?vue&type=style&index=0&id=0dc397c8&scoped=true&lang=css"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dc397c8"]])

export default __exports__